var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-12 mx-2 caption subtleColor"},[_vm._v(" Synonyms on this page: "+_vm._s(_vm.aliases.join(", ").toLowerCase())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }